<template>
  <div>
    <v-chip-group row class="mb-3 montants" v-model="montantIndex" @change="udpateMontantDon">
      <v-chip
        filter
        large
        tile
        color="primary"
        class="montant"
        outlined
        v-for="montant in montants.sort()"
        :key="montant"
        @click="innerValue = montant"
        :disabled="disabled"
      >
        <div>{{ montant | money }}</div>
      </v-chip>
      <v-chip filter large tile color="primary" value="autre" class="montant" outlined :disabled="disabled"> {{ $t("formulaireDon.autre") }} </v-chip>
    </v-chip-group>
    <v-text-field
      type="number"
      minvalue="0"
      v-model.number="montantCustom"
      outlined
      style="max-width: max-content"
      v-if="showMontantCustom"
      step="5"
      :rules="montantDon"
      @input="udpateMontantDon"
      :disabled="disabled"
    >
      <template v-slot:label>{{ $t("formulaireDon.montant") }} *</template>
    </v-text-field>
  </div>
</template>

<script>
import Rules from "@/mixins/Rules"
export default {
  mixins: [Rules],
  data() {
    return {
      innerValue: 0,
      montantIndex: 0,
      showMontantCustom: false,
      montantCustom: ""
    }
  },
  props: {
    value: Number,
    montants: { type: Array },
    disabled: { type: Boolean, default: false }
  },
  mounted() {
    if (!isNaN(this.value)) {
      const index = this.montants.indexOf(this.value)
      if (index > -1) {
        this.montantIndex = index
      } else {
        this.montantIndex = "autre"
        this.montantCustom = this.value
      }
      this.udpateMontantDon()
      this.innerValue = this.value
    }
  },
  created() {},
  computed: {
    erreurMontant() {
      return !this.innerValue || this.innerValue <= 0 || this.innerValue !== Math.floor(this.innerValue)
    }
  },
  methods: {
    onChange() {
      this.$emit("input", this.innerValue)
    },
    udpateMontantDon() {
      if (this.montantIndex === "autre") {
        this.showMontantCustom = true
        this.innerValue = parseInt(this.montantCustom)
      } else {
        this.showMontantCustom = false
        this.innerValue = this.montants[this.montantIndex]
      }
      this.onChange()
    }
  }
}
</script>

<style>
.montants .v-chip.montant {
  border-radius: 0;
}
</style>